﻿/*************** LUIGIS BOX MAGNIFIER ICON CLICKABLE FIX START ***********************/
document.addEventListener('DOMContentLoaded', function () {
    var icon = document.querySelector('.js-search-icon');
    var main = document.querySelector('.header-main');
    var form = document.querySelector('.header-main-search form');
    var input = document.querySelector('#autocomplete');
    if (!icon || !form || !input) return;

    // Gør IMG klik/tastbar
    icon.style.cursor = 'pointer';
    icon.setAttribute('role', 'button');
    icon.setAttribute('tabindex', '0');
    icon.setAttribute('aria-label', 'Åbn søgning');

    // Små helpers for ældre browsere
    function isMobile() {
        return window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : (window.innerWidth <= 767);
    }
    function hasClass(el, c) { return el.classList ? el.classList.contains(c) : new RegExp('(^|\\s)' + c + '(\\s|$)').test(el.className); }
    function addClass(el, c) { if (el.classList) el.classList.add(c); else if (!hasClass(el, c)) el.className += ' ' + c; }
    function dispatchFocus(el) {
        try { el.dispatchEvent(new Event('focus', { bubbles: true })); }
        catch (e) { var ev = document.createEvent('Event'); ev.initEvent('focus', true, true); el.dispatchEvent(ev); }
    }
    function ensureLBX() {
        if (window.Luigis && Luigis.SearchDefer && !Luigis.SearchDefer.initialized) {
            try { Luigis.SearchDefer.initSearch(); } catch (_) { }
        }
    }
    function openAndFocus() {
        if (main && !hasClass(main, 'is-search-open')) addClass(main, 'is-search-open');
        ensureLBX();
        try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
        dispatchFocus(input);
    }
    function handleClick() {
        if (isMobile() && !hasClass(main, 'is-search-open')) { openAndFocus(); return; }
        if (!input.value.trim()) { openAndFocus(); return; }
        form.submit();
    }

    icon.addEventListener('click', function (e) { e.preventDefault(); handleClick(); });
    icon.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); }
        // IE11 fallback
        if (e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); handleClick(); }
    });
});
/*************** LUIGIS BOX MAGNIFIER ICON CLICKABLE FIX END ***********************/